import { useEffect, useRef } from 'react';

import { ChakraBox, FileClip } from '@equip.health/ui';
import { v1 as uuidv1 } from 'uuid';

import {
  CHAT_INPUT_ACCEPT,
  FILE_SIZE_ERROR_DURATION,
  FILE_SIZE_LIMIT_MESSAGE,
} from '~/lib/constants/chat.constants';
import { FileAttachment } from '~/lib/types/chat';
import { isValidFileSizeLimit } from '~/lib/util/chat/chat.utils';

const idPrefix = 'chat';
const idPostfix = 'attachments';

export interface ChatAttachmentsProps {
  id: string;
  isMessageSent: boolean;
  onFileSelected?: (file?: FileAttachment) => void;
  onFileSizeError: (value: string) => void;
}
const ChatAttachments = ({
  id,
  isMessageSent,
  onFileSelected,
  onFileSizeError,
}: ChatAttachmentsProps) => {
  const attachmentRef = useRef<HTMLInputElement>();
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        timeoutRef.current = null;
      }
    };
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileObj = event.target.files[0];
    if (fileObj && !isValidFileSizeLimit(fileObj.size)) {
      onFileSizeError(`${fileObj.name} ${FILE_SIZE_LIMIT_MESSAGE}`);
      timeoutRef.current = setTimeout(
        () => onFileSizeError(null),
        FILE_SIZE_ERROR_DURATION,
      );
    } else if (fileObj) {
      const file = {
        file: fileObj,
        name: `${uuidv1()}-${fileObj.name}`,
      } as FileAttachment;

      onFileSelected?.(file);
    }

    // 👇️ reset file input
    // eslint-disable-next-line no-param-reassign
    event.target.value = null;
  };

  return (
    <ChakraBox
      cursor="pointer"
      id={`${idPrefix}-mentions-send-container__${id}__${idPostfix}`}
      onClick={() => attachmentRef?.current?.click?.()}
      padding="10px"
    >
      {!attachmentRef.current?.value && !isMessageSent && (
        <FileClip
          fill="teal"
          id={`${idPrefix}-mentions-attachment__${id}__${idPostfix}`}
        />
      )}

      <input
        accept={CHAT_INPUT_ACCEPT.join(', ')}
        hidden
        onChange={handleInputChange}
        ref={attachmentRef}
        title="fileMessage"
        type="file"
      />
    </ChakraBox>
  );
};

export default ChatAttachments;
